import { BtnContainer } from "@jeffcarbine/premmio/public/components/btn/btn.html.js";
import { EmbeddedSpotifyPlayer } from "@jeffcarbine/premmio/public/components/embeddedSpotifyPlayer/embeddedSpotifyPlayer.html.js";
import { Icon } from "@jeffcarbine/premmio/public/components/icon/icon.html.js";

import { formatDate } from "@jeffcarbine/premmio/public/modules/formatDate/formatDate.js";

export const EpisodeBox = (episode, isHomepage, i = 0) => {
  const epDate = new Date(episode.pubDate);
  const fullTitle = episode.title;

  let preTitle = "";
  let title = "";
  let postTitle = "";

  // Extract postTitle if it exists
  const firstParentheticalIndex = fullTitle.includes("(")
    ? fullTitle.indexOf("(")
    : fullTitle.length;
  postTitle = fullTitle.substring(firstParentheticalIndex);

  // Check for the first format "Pre-Title: Episode Title (Post Title)"
  if (fullTitle.includes(": ")) {
    const firstColonIndex = fullTitle.indexOf(": ") + 2;

    preTitle = fullTitle.substring(0, fullTitle.indexOf(":"));
    title = fullTitle.substring(firstColonIndex, firstParentheticalIndex);
  } else if (fullTitle.includes(" - ")) {
    // Check for the second format "Pre-Title - Episode Title (Post Title)"
    const firstHyphenIndex = fullTitle.indexOf(" - ") + 3;

    preTitle = fullTitle.substring(0, fullTitle.indexOf(" - "));
    title = fullTitle.substring(firstHyphenIndex, firstParentheticalIndex);
  }

  let episodeBox = {
    class: "episode-container",
    child: {
      class: "episodeBox",
      child: {
        class: "container",
        children: [
          {
            children: [
              {
                tagName: "span",
                children: [
                  {
                    if: !isHomepage,
                    tagName: "h3",
                    class: "f12 episodeDate",
                    textContent: formatDate(epDate),
                  },
                  {
                    tagName: "h2",
                    textContent: title,
                    prepend: {
                      if: preTitle !== false,
                      tagName: "span",
                      class: "preTitle",
                      textContent: preTitle,
                    },

                    append: {
                      if: postTitle,
                      tagName: "span",
                      class: "postTitle",
                      textContent: postTitle,
                    },
                  },
                  {
                    if: isHomepage,
                    child: new EmbeddedSpotifyPlayer(episode.spotifyLink),
                  },
                  {
                    if: episode.patreonExclusive,
                    tagName: "span",
                    class: "banner",
                    children: [
                      new Icon("patreon"),
                      {
                        tagName: "span",
                        textContent: "Patreon Exclusive",
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            style: i === 0 ? "height: auto" : "",
            children: [
              {
                if: !isHomepage,
                class: "description",
                child: {
                  tagName: "p",
                  innerHTML: episode.description,
                },
              },
              // {
              //   tagName: "button",
              //   class: "descriptionExpander",
              //   textContent: "Read More",
              // },
              // {
              //   if: isHomepage,
              //   class: "audio",
              //   children: [
              //     {
              //       if: episode.patreonExclusive,
              //       tagName: "a",
              //       class: "btn",
              //       href: "https://patreon.com" + episode.patreonLink,
              //       target: "blank",
              //       child: {
              //         tagName: "span",
              //         class: "has-img",
              //         textContent: "Listen on Patreon",
              //         child: {
              //           tagName: "img",
              //           src: "https://doih87m1dc6d2.cloudfront.net/images/icons/patreon.webp",
              //         },
              //       },
              //     },
              //     AudioPlayer(
              //       episode.rssLink,
              //       episode.title.replaceAll("&amp;", "&"),
              //       !episode.patreonExclusive
              //     ),
              //   ],
              // },
              // {
              //   if: isHomepage,
              //   class: "platforms",
              //   children: [
              //     {
              //       if:
              //         episode.patreonVideoLink !== null &&
              //         episode.patreonVideoLink !== undefined,
              //       tagName: "a",
              //       class: "btn",
              //       href: "https://patreon.com" + episode.patreonVideoLink,
              //       target: "blank",
              //       child: {
              //         tagName: "span",
              //         class: "has-img",
              //         textContent: "Video on Patreon",
              //         child: {
              //           tagName: "img",
              //           src: "https://doih87m1dc6d2.cloudfront.net/images/icons/patreon.webp",
              //         },
              //       },
              //     },
              //     {
              //       if:
              //         !episode.patreonExclusive &&
              //         episode.patreonLink !== "" &&
              //         episode.patreonLink !== null &&
              //         episode.patreonLink !== undefined,
              //       tagName: "a",
              //       class: "btn",
              //       href: "https://patreon.com" + episode.patreonLink,
              //       target: "blank",
              //       child: {
              //         tagName: "span",
              //         class: "has-img",
              //         textContent: "Ad-free on Patreon",
              //         child: {
              //           tagName: "img",
              //           src: "https://doih87m1dc6d2.cloudfront.net/images/icons/patreon.webp",
              //         },
              //       },
              //     },
              //     {
              //       if:
              //         episode.aftershowLink !== "" &&
              //         episode.aftershowLink !== null &&
              //         episode.aftershowLink !== undefined,
              //       tagName: "a",
              //       class: "btn",
              //       href: "https://patreon.com" + episode.aftershowLink,
              //       target: "blank",
              //       child: {
              //         tagName: "span",
              //         class: "has-img",
              //         textContent: "Short Rest",
              //         child: {
              //           tagName: "img",
              //           src: "https://doih87m1dc6d2.cloudfront.net/images/icons/patreon.webp",
              //         },
              //       },
              //     },
              //     {
              //       if:
              //         episode.appleLink !== "" &&
              //         episode.appleLink !== null &&
              //         episode.appleLink !== undefined,
              //       tagName: "a",
              //       class: "btn",
              //       href: episode.appleLink,
              //       target: "blank",
              //       child: {
              //         tagName: "span",
              //         class: "has-img",
              //         textContent: "Listen on Apple",
              //         child: {
              //           tagName: "img",
              //           src: "https://doih87m1dc6d2.cloudfront.net/images/icons/apple-podcasts.webp",
              //         },
              //       },
              //     },
              //     {
              //       if:
              //         episode.spotifyLink !== "" &&
              //         episode.spotifyLink !== null &&
              //         episode.spotifyLink !== undefined,
              //       tagName: "a",
              //       class: "btn",
              //       href: episode.spotifyLink,
              //       target: "blank",
              //       child: {
              //         tagName: "span",
              //         class: "has-img",
              //         textContent: "Listen on Spotify",
              //         child: {
              //           tagName: "img",
              //           src: "https://doih87m1dc6d2.cloudfront.net/images/icons/spotify.webp",
              //         },
              //       },
              //     },
              //   ],
              // },
              {
                // if: !isHomepage,
                class: "episodePageLink",
                child: new BtnContainer(
                  {
                    href: `/episodes/episode/${episode.localPath}`,
                    textContent: isHomepage
                      ? "View Episode"
                      : "Listen to this Episode",
                  },
                  "centered"
                ),
              },
            ],
          },
        ],
      },
    },
  };

  return episodeBox;
};
